import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Models
import mDevice from 'models/device';
import { isMotherboard } from 'models/deviceSlave';
// Custom
import { deviceDataShape } from 'constants/PropTypesShapes';

const ScenarioLogExecConflict = ({ conflict, device }) => {
  const slave = mDevice.slaveFromRelay(conflict.idRelay, device);
  const relay = mDevice.relay(conflict.idRelay, device);
  const delay = conflict.delay / 10;

  return (
    <div className="row m-0 pl-3">
      <strong>
        <LocalizedMessage id="info.scenarioExecConflict" values={{ delay, relay: relay ? relay.code : 'unknown' }} />
      </strong>
      {slave && (
        <div className="ml-1">
          (
          <LocalizedMessage id="title.deviceSlave" values={{ isMotherboard: isMotherboard(slave), desc: slave.name }} />
          )
        </div>
      )}
    </div>
  );
};

ScenarioLogExecConflict.propTypes = {
  conflict: PropTypes.shape({
    delay: PropTypes.number.isRequired,
    idRelay: PropTypes.number.isRequired,
  }).isRequired,
  device: deviceDataShape.isRequired,
};

module.exports = ScenarioLogExecConflict;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/logs/ScenarioLogExecConflict.js